export const UTILS_CALLS = {
    "cloudinary-signature": {
        "use_mock": false,
        "mock_endpoint": "media/images/generate-signature",
        "api_type": "POST",
        "over_ride_global_mock": true,
        "requires_auth" : true
    }
}